import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class InvoiceOutgoingModel extends Model {
  static reducer(action, InvoiceOutgoingModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.InvoiceOutgoing.schema:
        action.payload.forEach((payload) => {
          const dbData = InvoiceOutgoingModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          InvoiceOutgoingModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
InvoiceOutgoingModel.modelName = "InvoiceOutgoingModel";

InvoiceOutgoingModel.fields = {
  id: attr(),
};

export default InvoiceOutgoingModel;